import React from 'react';
import Layout from '../layout/Layout';
import Section from '../ui/Section';
import Container from '../ui/Container';
import Sparkle from '../ui/Sparkle';
import { getArticle, relatedArticles } from '../../content/library';
import { CONTACT } from '../layout/siteData';

const NotFound = () => (
  <Layout>
    <Section tone="cream" pad="lg">
      <Container>
        <h1 className="text-h1 font-extrabold text-ink">Article not found</h1>
        <p className="mt-3"><a href="/help-center" className="text-ink font-bold">← Back to the Help Center</a></p>
      </Container>
    </Section>
  </Layout>
);

const HelpArticle = ({ slug }) => {
  const article = getArticle(slug);
  if (!article) return <NotFound />;
  const related = relatedArticles(slug, article.category, 6);

  return (
    <Layout>
      <header className="relative overflow-hidden bg-sky">
        <Sparkle size={110} color="#95a8e6" className="pointer-events-none absolute -top-3 right-[6%] opacity-25 hidden sm:block" />
        <Container className="relative py-10 md:py-14">
          <nav className="flex items-center gap-2.5 text-sm font-bold text-muted mb-4" aria-label="Breadcrumb">
            <a href="/help-center" className="text-ink">Help Center</a>
            <span aria-hidden="true">/</span>
            <span>{article.category}</span>
          </nav>
          <h1 className="text-[clamp(1.9rem,4vw,2.8rem)] font-extrabold text-ink leading-tight tracking-tight max-w-[22ch]">{article.title}</h1>
        </Container>
      </header>

      <Section tone="white" pad="md">
        <div className="grid lg:grid-cols-[1fr_300px] gap-12 items-start">
          <article className="max-w-[720px]">
            <div className="flex gap-4 bg-cream border border-line border-l-4 border-l-brand rounded-2xl p-7">
              <Sparkle size={22} color="#95a8e6" className="flex-none" />
              <div>
                <h2 className="text-xl font-extrabold text-ink mb-2.5">We’re putting the finishing touches on this guide.</h2>
                <p className="text-body leading-relaxed">This help article is being migrated to our new Help Center. In the meantime, our 100% South African Customer Success Team is ready to walk you through <strong className="text-ink">{article.title.toLowerCase()}</strong> personally.</p>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4 mt-7">
              <a href={`mailto:${CONTACT.email}?subject=Help: ${encodeURIComponent(article.title)}`} className="bg-white border border-line rounded-2xl p-5 hover:-translate-y-0.5 hover:border-brand hover:shadow-soft transition-all">
                <strong className="block text-ink mb-1.5">Email our team</strong><span className="text-ink font-semibold text-[0.9rem]">{CONTACT.email}</span>
              </a>
              <a href="/contact" className="bg-white border border-line rounded-2xl p-5 hover:-translate-y-0.5 hover:border-brand hover:shadow-soft transition-all">
                <strong className="block text-ink mb-1.5">Contact page</strong><span className="text-ink font-semibold text-[0.9rem]">Email & live chat</span>
              </a>
            </div>
          </article>

          <aside className="lg:sticky lg:top-28 bg-cream border border-line rounded-3xl p-7">
            <h3 className="text-base font-extrabold text-ink mb-4">More in {article.category}</h3>
            <ul className="flex flex-col">
              {related.map((a) => (
                <li key={a.slug}><a href={`/help-center/${a.slug}`} className="block py-2.5 text-[0.95rem] font-semibold text-body border-b border-line hover:text-ink transition-colors">{a.title}</a></li>
              ))}
            </ul>
            <a href="/help-center" className="inline-block mt-4 font-bold text-ink">Browse all help →</a>
          </aside>
        </div>
      </Section>
    </Layout>
  );
};

export default HelpArticle;
